<template>
  <Modal :id="id" title="Course Flyer Upload" :hideFooter="true">
    <div slot="body" class="modal-body">
      <div class="alert alert-info">
        NOTE: File uploads may not exceed <strong>{{ maxUpload }}</strong> in
        size.
      </div>
      <div class="dropzone" :id="dropzoneId">
        <div class="text-center">
          <button type="button" class="btn btn-primary">Choose File</button>
          <a
            v-if="!!uploaded"
            :href="route('training.events.flyer.download', routeParam)"
            :data-file="filename"
            class="btn btn-success ml-2"
          >
            <span class="icon icon-download"></span>
            <span class="text">View Uploaded File</span>
          </a>
        </div>
        <div class="dropzone-preview mt-3"></div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import Dropzone from "dropzone";

export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "flyer-upload-modal",
      dropzoneId: "dz-flyer-upload",
      dropzoneUrl: null,
      errorMessage: null,
      event: null,
      maxUpload: null,
      uploaded: false,
      filename: null,
    };
  },

  computed: {
    routeParam() {
      return { event: this.event.id };
    },
  },

  methods: {
    load() {
      this.axios
        .get(this.route("training.events.refresh-uploads", this.routeParam))
        .then((response) => {
          this.event.flyer_upload = response.data.flyer_upload;
          this.uploaded = !!this.event.flyer_upload;
        });
    },

    initDropzone() {
      let token = document.head.querySelector('meta[name="csrf-token"]');
      Dropzone.autoDiscover = false;

      this.dropzone = new Dropzone(`#${this.dropzoneId}`, {
        acceptedFiles: ".pdf",
        url: this.route("training.events.flyer.upload", this.routeParam),
        paramName: "file",
        withCredentials: true,
        headers: { "X-CSRF-Token": token.content },
        clickable: `#${this.dropzoneId} button`,
        previewsContainer: `#${this.dropzoneId} .dropzone-preview`,
        hiddenInputContainer: `#${this.dropzoneId} .dropzone-preview`,
        thumbnailMethod: "contain",
      });

      let me = this;
      this.dropzone.on("success", (file, response) => {
        this.axios
          .post(this.route("training.events.flyer.store", this.routeParam), {
            file: response.file,
          })
          .then(() => {
            setTimeout(() => {
              me.dropzone.removeFile(file);
              me.uploaded = true;
              me.filename = response.file;
            }, 3000);
          });
      });

      this.dropzone.on("error", (file, response) => {
        console.error(response);
      });
    },
  },

  mounted() {
    this.event = _.cloneDeep(this.options.event);
    this.maxUpload = this.options.maxUpload;
    this.load();
    this.initDropzone();
  },
};
</script>

<style>
#dz-flyer-upload {
  border: none;
  min-height: 0;
  padding: 0;
}
</style>
